<template>
  <Layout>
    <div class="is-size-7 p-md g-game-page">
      <div class="has-text-centered">
        <GameTile :game="game" class="has-text-left" />
        <a :href="game.path" class="button is-primary has-text-black is-size-3" style="width:80%">{{ $t('PLAY NOW!') }}</a>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/GG'
import GameTile from '@/components/LangGG/GameTile'

export default {
  name: 'Home',
  components: {
    Layout,
    GameTile
  },
  data () {
    const id = this.$route.params.id
    const game = this.$store.state.games.games.find(game => game.id == id)
    return {
      game
    }
  }
}
</script>


<style>
.g-game-page {
  display: grid;
  grid-template-columns: repeat(1,minmax(0,1fr));
  gap: 0.5rem;
}
@media (min-width: 800px) { 
  .g-game-page {
    grid-template-columns: repeat(2,minmax(0,1fr));
    gap: 1rem;
  }
}
@media (min-width: 1200px) { 
  .g-game-page {
    grid-template-columns: repeat(3,minmax(0,1fr));
    gap: 1.5rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/LangGG/GamePage.vue